export default __webpack_public_path__ + "static/media/hm-rk-img.34abe48b.webp";